//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Col, Row } from 'antd';
import queryString from 'query-string';
import React, { useMemo } from 'react';
import { useLocation } from "react-router-dom";
import { userImg } from "utils/assets/images";
import { getAvatar } from 'utils/assets/images/lootie';
import searchHereSvg from "../../utils/assets/images/search-here.svg";
import { useCurrentUser, useUserProfileConfig } from "store/users/selectors";
import { useCurrentClass } from 'store/classes/selectors';
import { get } from 'lodash'
import useActiveStudentofParent from 'components/hooks/parent/activeStudentofParent';
import styled from 'styled-components';
import SentryWrap from 'components/Sentry';

//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------
const getTab = (key = "") => {
    switch (key) {
        case 'home':
            return key;
        case 'assessments':
            return key;
        case 'studentData':
            return key;
        default:
            return "home";
    }
}

export default function DashboardHeader({
    handleTabs = () => {},
    searchAssignment,
    onSearchChange
}) {
    const location = useLocation();
    const currentClass = useCurrentClass();
    const currentUser = useCurrentUser();
    const search = queryString.parse(location.search);
    const searchView = getTab(search.view ? search.view : "home");
    const { profile_config } = useUserProfileConfig()
    const currentDay = new Date().toLocaleDateString('en-US', { weekday: 'long' });
    const { activeStudentData } = useActiveStudentofParent();

    const handleChangeSearch = (e) => {
        const val = e.target.value;
        onSearchChange(val);
    };

    const getUserProfileImg = useMemo(() => {
        if (profile_config && profile_config.config) {
            const avt = getAvatar(profile_config.config.profile_pic)
            if (avt) {
                return avt
            }
        }
        return userImg;
    }, [profile_config])

    return (
        <SentryWrap>
            <Row>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 14 }} lg={{ span: 15 }}>
                    <div className='weekDaysInfo'>
                        <div className='weekDays'>
                            <label>¡Hola, {currentUser?.firstName}!</label>
                            <span>Happy {currentDay}!</span>
                        </div>
                        <div className='avtarInfo'>
                            <img src={getUserProfileImg} />
                            <label>{currentClass.displayName}</label>
                        </div>
                        {searchView == "studentData" && (
                            <div className='searchHere'>
                               <img src={searchHereSvg} alt="" /> 
                               <input type='text' placeholder='Search Here' onChange={handleChangeSearch} />
                            </div>
                        )}
                    </div>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10 }} lg={{ span: 9 }}>
                  <div className='tabButtonUpr'>
                    <button className={`tabButtonHome ${searchView === 'home' ? 'tabButtonActive' : ''}`} onClick={() => handleTabs("home")}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="35" viewBox="0 0 39 35" fill="none">
                            <g clip-path="url(#clip0_1_232)">
                                <path d="M33.96 17.27V32.9C33.96 33.7 33.31 34.36 32.5 34.36H24.76V21H13.98V34.36H6.24003C5.44003 34.36 4.78003 33.71 4.78003 32.9V17.27L19.36 6.98999L33.94 17.27H33.96Z" fill="white" />
                                <path d="M36.4999 16.5801C36.0499 16.5801 35.5999 16.4501 35.1999 16.1701L19.3699 5.01006L3.54994 16.1701C3.15995 16.4501 2.69994 16.5801 2.24994 16.5801C1.53994 16.5801 0.849945 16.2501 0.409945 15.6301C-0.310055 14.6101 -0.060055 13.2101 0.949945 12.4901L18.0799 0.410059C18.8599 -0.139941 19.8999 -0.139941 20.6799 0.410059L37.7999 12.4801C38.8199 13.2001 39.0599 14.6001 38.3399 15.6201C37.8999 16.2401 37.1999 16.5701 36.4999 16.5701V16.5801Z" fill="white" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1_232">
                                    <rect width="38.75" height="34.36" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <label>HOME</label>
                    </button>
                    {get(currentUser, 'role', '') !== 'parent' && (
                    <button className={`tabCalBtn ${searchView === 'assessments' ? 'tabButtonActive' : ''}`} onClick={() => handleTabs('assessments')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="36" viewBox="0 0 32 36" fill="none">
                            <g clip-path="url(#clip0_1_245)">
                                <path d="M-9.76585e-06 12.79V32.74C-9.76585e-06 34.06 1.06999 35.13 2.38999 35.13H29.29C30.61 35.13 31.68 34.06 31.68 32.74V12.79H-0.0100098H-9.76585e-06ZM7.54999 22.55L9.32999 20.77C9.68999 20.41 10.28 20.41 10.64 20.77L14.4 24.53L21.06 17.87C21.42 17.51 22.01 17.51 22.37 17.87L24.15 19.65C24.51 20.01 24.51 20.6 24.15 20.96L15.08 30.03C14.71 30.4 14.1 30.4 13.73 30.03L7.55999 23.86C7.19999 23.5 7.19999 22.91 7.55999 22.55H7.54999Z" fill="#9BF4D0" />
                                <path d="M12.66 5.98C13.14 5.98 13.53 5.59 13.53 5.11V0.87C13.53 0.39 13.14 0 12.66 0C12.18 0 11.79 0.39 11.79 0.87V5.11C11.79 5.59 12.18 5.98 12.66 5.98Z" fill="#9BF4D0" />
                                <path d="M19.03 5.98C19.51 5.98 19.9 5.59 19.9 5.11V0.87C19.9 0.39 19.51 0 19.03 0C18.55 0 18.16 0.39 18.16 0.87V5.11C18.16 5.59 18.55 5.98 19.03 5.98Z" fill="#9BF4D0" />
                                <path d="M25.4 5.98C25.88 5.98 26.27 5.59 26.27 5.11V0.87C26.27 0.39 25.88 0 25.4 0C24.92 0 24.53 0.39 24.53 0.87V5.11C24.53 5.59 24.92 5.98 25.4 5.98Z" fill="#9BF4D0" />
                                <path d="M29.29 3.01001H27.35V5.08001C27.35 6.16001 26.47 7.04001 25.39 7.04001C24.31 7.04001 23.43 6.16001 23.43 5.08001V3.01001H20.97V5.08001C20.97 6.16001 20.09 7.04001 19.01 7.04001C17.93 7.04001 17.05 6.16001 17.05 5.08001V3.01001H14.59V5.08001C14.59 6.16001 13.71 7.04001 12.63 7.04001C11.55 7.04001 10.67 6.16001 10.67 5.08001V3.01001H8.20996V5.08001C8.20996 6.16001 7.32996 7.04001 6.24996 7.04001C5.16996 7.04001 4.28996 6.16001 4.28996 5.08001V3.01001H2.34996C1.02996 3.01001 -0.0400391 4.08001 -0.0400391 5.40001V11.25H31.65V5.40001C31.65 4.08001 30.58 3.01001 29.26 3.01001H29.29Z" fill="#9BF4D0" />
                                <path d="M6.29004 5.98C6.77004 5.98 7.16004 5.59 7.16004 5.11V0.87C7.16004 0.39 6.77004 0 6.29004 0C5.81004 0 5.42004 0.39 5.42004 0.87V5.11C5.42004 5.59 5.81004 5.98 6.29004 5.98Z" fill="#9BF4D0" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1_245">
                                    <rect width="31.69" height="35.14" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <label>CALENDAR</label>
                    </button>
                    )}

                    <button className={`tabSDBtn ${searchView === 'studentData' ? 'tabButtonActive' : ''}`}  onClick={() => handleTabs('studentData')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="42" viewBox="0 0 27 42" fill="none">
                            <g clip-path="url(#clip0_1_263)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.81 14.2H10.9L4.60999 1.29C5.97999 0.73 7.42999 0.3 8.92999 0L13.39 9.18L13.69 9.77L13.96 10.33L15.3 13.1L15.57 13.66L15.81 14.2Z" fill="#F1543F" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.94 18.85H10.84C10.68 18.85 10.52 18.74 10.49 18.58L9.47003 15.36C9.34003 14.9 9.42002 14.42 9.71002 14.04C10.01 13.66 10.41 13.45 10.89 13.45H15.88C16.36 13.45 16.79 13.66 17.09 14.04C17.39 14.42 17.47 14.9 17.3 15.36L16.33 18.58C16.22 18.74 16.12 18.85 15.93 18.85H15.94ZM11.08 18.1H15.67L16.56 15.15C16.64 14.91 16.61 14.69 16.45 14.51C16.32 14.32 16.13 14.21 15.86 14.21H10.89C10.68 14.21 10.46 14.32 10.3 14.51C10.17 14.7 10.11 14.91 10.19 15.15L11.08 18.1Z" fill="white" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M26.06 29.53C26.84 28.75 26.84 27.52 26.06 26.74C25.5 26.18 25.31 25.32 25.66 24.57C26.06 23.55 25.58 22.4 24.56 21.97C23.81 21.67 23.32 20.95 23.32 20.14C23.32 19.04 22.41 18.15 21.33 18.15C20.55 18.15 19.8 17.67 19.48 16.92C19.08 15.9 17.92 15.42 16.9 15.82C16.15 16.12 15.32 15.98 14.73 15.42C13.95 14.61 12.72 14.61 11.91 15.42C11.35 15.98 10.49 16.17 9.72999 15.82C8.71 15.42 7.56 15.9 7.15 16.92C6.85 17.67 6.13 18.15 5.3 18.15C4.23 18.15 3.31 19.04 3.31 20.14C3.31 20.92 2.83 21.67 2.08 21.97C1.06 22.4 0.579995 23.55 1.01 24.57C1.31 25.32 1.14 26.13 0.579995 26.74C-0.200005 27.52 -0.200005 28.75 0.579995 29.53C1.14 30.09 1.33 30.95 1.01 31.7C0.579995 32.72 1.06 33.88 2.08 34.3C2.83 34.6 3.31 35.32 3.31 36.13C3.31 37.23 4.22 38.12 5.3 38.12C6.11 38.12 6.86 38.63 7.15 39.36C7.55 40.38 8.71 40.86 9.72999 40.46C10.48 40.16 11.31 40.3 11.91 40.86C12.72 41.67 13.95 41.67 14.73 40.86C15.29 40.3 16.15 40.11 16.9 40.46C17.92 40.86 19.07 40.38 19.48 39.36C19.8 38.63 20.5 38.12 21.33 38.12C22.4 38.12 23.32 37.23 23.32 36.13C23.32 35.35 23.8 34.6 24.56 34.3C25.58 33.87 26.06 32.72 25.66 31.7C25.34 30.92 25.5 30.09 26.06 29.53Z" fill="#FFD05B" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M22.76 28.1399C22.76 22.9299 18.54 18.6899 13.34 18.6899C8.14001 18.6899 3.89001 22.9299 3.89001 28.1399C3.89001 33.3499 8.11001 37.5899 13.34 37.5899C18.57 37.5899 22.76 33.3499 22.76 28.1399Z" fill="#F9B54C" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M22.14 1.29L15.86 14.2H10.95L11.22 13.66L11.46 13.1L12.83 10.33L13.1 9.77L13.4 9.18L17.85 0C19.33 0.3 20.78 0.73 22.15 1.29H22.14Z" fill="#FF7058" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1_263">
                                    <rect width="26.65" height="41.47" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <label>STUDENT DATA</label>
                    </button>
                  </div>
                </Col>
                {currentUser?.role === "parent" ? (
                     <Title className="breakTheSentence 1212 setCstmSpc">{activeStudentData?.firstName + ' ' + activeStudentData?.lastName}</Title>
                ): null}
            </Row>
        </SentryWrap>
    );
};

const Title = styled.span`
    display: inline-block;
    background-color: #ff682c;
    color: #ffffff;
    font-size: 12px;
    border-radius: 7px;
    padding: 4px 13px 4px 13px !important;
    font-weight: 500;
    line-height: 18px;
    text-transform: uppercase;
    letter-spacing: .5px;
    width: fit-content;
`;